import { Skeleton } from '@/components/ui/skeleton/skeleton.component';

type Props = {
  // all of these are passed from the layout component
  leftWidth?: number;
  rightWidth?: number;
  height?: number;
};

export const PreTailoringSkeleton = ({ leftWidth, rightWidth, height }: Props) => {
  return (
    <div className="mt-[144px] mx-18 pt-6 pb-4 flex flex-row justify-between">
      <div className="flex gap-x-4">
        <div
          className="flex flex-col gap-y-4 rounded shadow border border-light-gray flex-1 py-4 px-7"
          style={{
            overflowY: 'scroll',
            width: leftWidth,
            height,
          }}
        >
          <div className="flex flex-row justify-between mt-4">
            <Skeleton className="h-6 w-[200px]" />
            <Skeleton className="h-4 w-[300px]" />
          </div>
          <div className="flex flex-row justify-between gap-x-4">
            <Skeleton className="h-8 w-[300px]" />
            <Skeleton className="h-8 w-[260px]" />
          </div>
          <div className="flex flex-row justify-between gap-x-4">
            <Skeleton className="h-4 w-10" />
            <div className="flex flex-row gap-x-2">
              <Skeleton className="h-4 w-[100px]" />
              <Skeleton className="h-4 w-[120px]" />
              <Skeleton className="h-4 w-[120px]" />
            </div>
          </div>
          {Array.from(Array(8).keys()).map((i) => (
            <div key={i} className="rounded border border-light-gray shadow">
              <div className="p-4 flex flex-col gap-y-4">
                <Skeleton className="h-8 w-[350px]" />
                <Skeleton className="h-4 w-[650px]" />
              </div>
              <Skeleton className="h-12 flex-1 rounded-none rounded-bl rounded-br" />
            </div>
          ))}
        </div>
        <div
          style={{
            overflowY: 'scroll',
            width: rightWidth,
            height,
          }}
        >
          <div className="px-4 flex flex-col gap-y-2">
            <div className="flex flex-col gap-y-4">
              <Skeleton className="h-8 w-[250px]" />
              <div className="flex flex-row justify-start gap-x-2 mb-5">
                <Skeleton className="h-8 w-[200px]" />
                <Skeleton className="h-8 w-[200px]" />
              </div>
            </div>
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
            <Skeleton className="h-18" />
          </div>
        </div>
      </div>
    </div>
  );
};
